export const fetching = 'FETCHING_IMPORT_REQUESTS'
export const fetched = 'FETCHED_IMPORT_REQUESTS'
export const errored = 'ERROR_IMPORT_REQUESTS'
export const reset = 'RESET_IMPORT_REQUESTS'
export const newImport = 'NEW_IMPORT'
